<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-轮播图
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">

       <!--上下边距-->
            <el-form-item label="上下边距：">
                <el-slider v-model="curItem.style.paddingTop" show-input></el-slider>
            </el-form-item>
            <!--左右边距-->
            <el-form-item label="宽度：">
                <el-slider v-model="curItem.style.width" :min="0" :max="100" show-input></el-slider>
            </el-form-item>

            
            <el-form-item label="高度：">
                <el-slider v-model="curItem.style.height" :min="0" :max="1400" show-input></el-slider>
                <div>0是默认高度</div>
            </el-form-item>

              <el-form-item label="圆角：">
              <el-slider v-model="curItem.style.yj" :min="0" :max="100" show-input>
              </el-slider>
              </el-form-item>

                <!--背景颜色-->
      <el-form-item label="背景颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
        </div>
      </el-form-item>


      <!-- <el-form-item label="指示点形状：">
                    <el-radio-group v-model="curItem.style.btnShape">
                        <el-radio :label="3">圆形</el-radio>
                        <el-radio :label="6">正方形</el-radio>
                        <el-radio :label="9">长方形</el-radio>
                      </el-radio-group>
                  </el-form-item> -->
      <el-form-item label="指示点颜色：">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.btnColor"></el-color-picker>
          <el-button
            type="button"
            style="margin-left: 10px"
            @click.stop="
              $parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')
            "
            >重置
          </el-button>
        </div>
      </el-form-item>
      <!-- <el-form-item label="广告来源：">
        <el-select v-model="curItem.params.adv_id" clearable>
          <el-option
            v-for="item in advList"
            :value="item.adv_id"
            :key="item.adv_id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="切换时间：">
        <el-input v-model="curItem.params.interval"></el-input>
        <p>轮播图自动切换的间隔时间，单位：毫秒</p>
      </el-form-item>
      <!--轮播高度-->
      <!-- <el-form-item label="轮播图高度：">
        <el-slider v-model="curItem.style.height" :format-tooltip="formatTooltip" :min="180" :max="500"></el-slider>
      </el-form-item> -->
    </el-form>

    <div class="common-form">
      <span> 轮播内容</span>
    </div>

    <el-form size="small" :model="curItem" label-width="100px">
      <!-- <el-form-item label="图片："> -->
      <el-form-item>
        <div
          class="param-img-item"
          :key="index"
          v-for="(banner, index) in curItem.data"
        >
          <template v-if="!banner.type||banner.type != 'video'">
            <div class="delete-box">
              <i
                class="el-icon-delete-solid"
                @click="$parent.onEditorDeleleData(index, selectedIndex)"
              ></i>
            </div>
            <div class="pic">
              <img
                v-img-url="banner.imgUrl"
                alt=""
                @click="$parent.onEditorSelectImage(banner, 'imgUrl')"
              />
            </div>
            <p class="tc gray9">建议尺寸比例750x360 像素，多个图片请保持尺寸一致</p>
            <div class="d-s-c">
              <div class="url-box flex-1">
                <span class="key-name">跳转地址：</span>
                <el-input
                  placeholder="请选择跳转地址"
                  :value="banner.name+banner.linkUrl"
                ></el-input>
              </div>
              <div class="url-box ml10">
                <el-button type="primary" @click="changeLink(index)"
                  >选择链接</el-button
                >
              </div>
            </div>
          </template>
          <template v-if="banner.type == 'video'">
            <div class="delete-box">
              <i
                class="el-icon-delete-solid"
                @click="$parent.onEditorDeleleData(index, selectedIndex)"
              ></i>
            </div>
            <div class="video">
              <!-- <img
                    v-img-url="banner.imgUrl"
                    alt=""
                    @click="$parent.onEditorSelectImage(banner, 'imgUrl')"
                /> -->
              <video :src="banner.video" controls></video>
            </div>
            <p class="tc gray9">建议尺寸比例750x360 像素</p>
            <div class="d-s-c">
              <div class="url-box flex-1">
                <span class="key-name">视频链接：</span>
                <el-input
                  disabled
                  placeholder="请选择视频链接地址"
                  v-model="banner.video"
                ></el-input>
              </div>
              <div class="url-box ml10">
                <!-- <el-button type="primary" @click="changeLink(index)"
                    >选择视频链接</el-button
                    > -->
                <el-button
                  type="primary"
                  @click="$parent.onEditorSelectImage(banner, 'video')"
                  >选择视频链接</el-button
                >
              </div>
            </div>
          </template>
        </div>

        <div class="d-c-c">
          <el-button @click="$parent.onEditorAddData()"
            >添加一个图片组件</el-button
          >
          <el-button @click="$parent.onEditorAddData('video')"
            >添加一个视频组件</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink
    >
  </div>
</template>

<script>
import Setlink from "@/components/setlink/Setlink";
import AdvApi from "@/api/adv.js";
export default {
  components: {
    Setlink,
  },
  data() {
    return {
      advList: [],
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    };
  },
  props: ["curItem", "selectedIndex"],
  created() {
    // this.getAdvList();
  },
  methods: {
    formatTooltip(val) {
      return (val*2) + ' px';
    },
    /*获取广告位*/
    // getAdvList() {
    //   AdvApi.advList("", true)
    //     .then((res) => {
    //       this.advList = res.data.list.data;
    //     })
    //     .catch((error) => {});
    // },
    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e) {
        this.curItem.data[this.index].linkUrl = e.url;
        this.curItem.data[this.index].name = "链接到" + " " + e.type + " " + e.name;
      }
    },
  },
};
</script>

<style>
.video {
  display: flex;
  align-items: center;
  justify-content: center;
}
.video video {
  width: 200px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/Banner.vue